// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayDescriptionWebsite_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionWebsite_localDraft_graphql.bs.js");

let convertFragment = PropertyWizardRelayDescriptionWebsite_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Website(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, props.draft);
  let websiteIsValid = PropertyWizardFormRelay__Validators__Description.Website.useIsValid(draft.fragmentRefs);
  let website = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.website = value;
      return newrecord;
    }
  }, props.stepHasBeenTouched, draft.draftProperty.website, websiteIsValid);
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(Form__Input.make, {
        labelText: "Website",
        optionalText: "optional",
        placeholderText: "https://www.123MainStreet.com",
        onChange: event => {
          let text = event.currentTarget.value;
          website.onChange(PropertyWizardRelayUtils.FormUtils.noneIfEmpty(text));
        },
        onBlur: param => website.onBlur(),
        onFocus: param => website.onFocus(),
        status: website.status,
        value: website.valueAsString
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: website.valid
      })
    ]
  });
}

let Components;

let TextInputField;

let Cell;

let Validators;

let FormUtils;

let Elements;

let make = PropertyWizardRelay__Description__Website;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
